import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import SuccessIcon from '../Icons/SuccessIcon';

interface Props {
  toggle(): void;
  filename: string;
}

const SuccessModal: React.FC<Props> = ({ toggle, filename }) => {
  const { t } = useTranslation(['includeTeam']);
  const navigate = useNavigate();

  function redirectToHistory() {
    navigate('?p=historico-importacoes');
  }

  return (
    <div className="success-wrapper" data-testid="success-many-modal">
      <div className="icon-wrapper">
        <SuccessIcon />
      </div>
      <span className="title-success">{t('includeTeam:file_success_title')}</span>
      <span className="subtitle">{t('includeTeam:ongoing')}</span>
      <span className="subtitle-two">
        {t('includeTeam:file_success_text')} <strong>{filename}</strong>
      </span>
      <button type="button" className="ok-button" onClick={redirectToHistory}>
        {t('includeTeam:import_history')}
      </button>
      <span className="new-file" onClick={toggle}>
        {t('includeTeam:include_new_file')}
      </span>
    </div>
  );
};

export default SuccessModal;
